//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		name: 'AppHeader',
		data() {
			return {
				searchQuery: ''
			}
		},
		methods: {
			jump: function(e) {
				this.$router.push(e);
			},
			handleSearch() {
				if (this.searchQuery.length>0) {
					if(this.$route.path != "/Resource"){
						let inSearch= this.searchQuery;
						this.searchQuery="";
						 this.$router.replace({
							path: "/Resource",
							name: "Resource",
							params: {
								Search: inSearch
							}
						 })
					}
				}else{
           			alert("请先输入搜索内容")
           		}
			}
		}
	}



// WEBPACK FOOTER //
// ./src/components/HeaderCpt.vue